import React from 'react';
import { components } from 'common';
import * as imageUtil from '@umu/umu-image-handle';
import { IDialogDataItem } from '@umu/umu-api/src/services/api/achievement/getUnreadDialogs';
import NavCloseIcon from '../../images/NavClose.png';

import './index.scss';

const { UMUBg } = components;

interface ICustomPopup extends IDialogDataItem {
    create_ts: string;
    creator_umu_id: string;
    display_strategy: string;
    end_ts: string;
    enterprise_id: string;
    id: string;
    name: string;
    picture: string;
    redirect_url: string;
    setup: string;
    start_ts: string;
    status: string;
    update_ts: string;
    visible_type: string;
}
interface IProps {
    baseInfo: {
        title: string;
        srcImg: string;
        link: string;
    };
    popupInfo: ICustomPopup;
    onClose: () => void;
    onImgClick: () => void;
}

const CustomPopup = (props: IProps) => {
    const { baseInfo, onClose, onImgClick } = props;
    return (
        <div className="popup-custom-dialog">
            <div className="content-img">
                <div onClick={onImgClick}>
                    <UMUBg clsName={`info-img ${baseInfo.link !== '' ? 'info-img-cursor' : ''}`} bgSrc={imageUtil.appendWidth(baseInfo.srcImg)}/>
                </div>
                <div className='close-dialog'>
                    <img src={imageUtil.appendWidth(NavCloseIcon)} className='icon-close-img' onClick={onClose}/>
                </div>
            </div>
        </div>
    );
};

export {
    ICustomPopup,
    CustomPopup,
}
